import { render } from "./CreateVariantDropdown.vue.js?vue&type=template&id=37ce3100!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CreateVariantDropdown.vue?vue&type=template&id=37ce3100"
import script from "./CreateVariantDropdown.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CreateVariantDropdown.vue?vue&type=script&lang=js"
export * from "./CreateVariantDropdown.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CreateVariantDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/components/stories/CreateVariantDropdown.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "37ce3100"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('37ce3100', __exports__)) {
    api.reload('37ce3100', __exports__)
  }
  
  module.hot.accept("./CreateVariantDropdown.vue.js?vue&type=template&id=37ce3100!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CreateVariantDropdown.vue?vue&type=template&id=37ce3100", () => {
    api.rerender('37ce3100', render)
  })

}


export default __exports__